import axios from 'axios'

const BASE_URL = 'https://api.ideal-postcodes.co.uk/v1'

export const searchAddressByPostcode = async (postcode) => {
  if (!postcode || postcode.trim().length === 0) {
    throw new Error('Postcode is required')
  }

  try {

    const cleanPostcode = postcode.replace(/\s/g, '').toUpperCase()

    const response = await axios.get(`${BASE_URL}/postcodes/${cleanPostcode}/?api_key=${process.env.REACT_APP_POSTCODE_API_KEY}`)
    //response is a list of addresses for postcode

    if (response.data?.result && Array.isArray(response.data?.result)) {
      return response.data.result.map((item, index) => {
        const formattedAddress = item.line_1 + ", " + item.line_2 + ", " + item.post_town + ", " + item.postcode

        return {
          id: index,
          formatted: formattedAddress,
          line_1: item.line_1,
          line_2: item.line_2,
          line_3: '',
          line_4: '',
          locality: '',
          town_or_city: item.post_town,
          county: item.county,
          district: '',
          country: 'England',
          postcode: item.postcode,
          // getAddressUrl: item.url,
        }
      })
    }

    return []
  } catch (error) {
    console.error(error)
    if (error.response?.status === 404) {
      throw new Error('No addresses found for this postcode')
    } else if (error.response?.status === 401) {
      throw new Error('Invalid API key')
    } else if (error.response?.status === 400) {
      throw new Error('Invalid postcode format')
    } else {
      throw new Error(`Address lookup failed: ${error.message}`)
    }
  }
}

export const formatAddressForDisplay = (address) => {
  return address.formatted || address.address || 'Invalid address'
}

// export const getDetailedAddress = async (url) => {
//   //OLD POSTCODE API, IF FUNCTION NEEDED, WILL NEED TO BE UPDATED TO MATCH NEW API
//   if (!API_KEY) {
//     throw new Error('getAddress.io API key not configured')
//   }

//   try {
//     const response = await axios.get(`${BASE_URL}${url}`, {
//       params: {
//         'api-key': API_KEY,
//       },
//     })

//     return response.data
//   } catch (error) {
//     throw new Error(`Failed to get detailed address: ${error.message}`)
//   }
// }
